var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7219 5.03975C11.9416 4.82008 12.2977 4.82008 12.5174 5.03975L19.0799 11.6023C19.1854 11.7077 19.2446 11.8508 19.2446 12C19.2446 12.1492 19.1854 12.2923 19.0799 12.3977L12.5174 18.9602C12.2977 19.1799 11.9416 19.1799 11.7219 18.9602C11.5022 18.7406 11.5022 18.3844 11.7219 18.1648L17.8866 12L11.7219 5.83525C11.5022 5.61558 11.5022 5.25942 11.7219 5.03975Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92012 5.03975C5.13979 4.82008 5.49595 4.82008 5.71562 5.03975L12.2781 11.6023C12.4978 11.8219 12.4978 12.1781 12.2781 12.3977L5.71562 18.9602C5.49595 19.1799 5.13979 19.1799 4.92012 18.9602C4.70045 18.7406 4.70045 18.3844 4.92012 18.1648L11.0849 12L4.92012 5.83525C4.70045 5.61558 4.70045 5.25942 4.92012 5.03975Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRight);
export default __webpack_public_path__ + "static/media/doubleRight.56961b4c8716404fa1dc50e73ae8ac66.svg";
export { ForwardRef as ReactComponent };